import React from 'react';
import TopGainers from '../components/TopGainers';

export default function Dashboard() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
      </div>

      <TopGainers />
    </div>
  );
}
